import { render } from "./PdfView.vue?vue&type=template&id=67502c48"
import script from "./PdfView.vue?vue&type=script&lang=js"
export * from "./PdfView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__